var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.header)?_c('h2',{staticClass:"CardHeader",class:_vm.header.class,style:(_vm.calculatedStyle),domProps:{"innerHTML":_vm._s(_vm.$t(_vm.header.text))}}):_vm._e()}
var staticRenderFns = []
export { render, staticRenderFns }